
// NPM Packages
import { getAuth } from "firebase/auth";

// Project files
import "./firebase"

export const authentication = getAuth();
